import providerLogos from '../../../../_mesomb/utils/providerLogos.ts';
import type { FundModel } from '../../../../types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'react-table';
import { QUERIES, toAbsoluteStatic } from '../../../../_mesomb/helpers';
import I18n from '../../../../_mesomb/i18n';
import CustomHeader from '../../../../_mesomb/partials/table/CustomHeader.tsx';
import DateCell from '../../../../_mesomb/partials/table/DateCell.tsx';
import MediaInfoCell from '../../../../_mesomb/partials/table/MediaInfoCell.tsx';
import NumberCell from '../../../../_mesomb/partials/table/NumberCell.tsx';
import PaginatedList from '../../../../_mesomb/partials/table/PaginatedList.tsx';
import { FundContributionModel as Transaction } from '../../../../types';

function FundContributions({ fund }: { fund: FundModel }) {
  const { t } = useTranslation();
  const columns = useMemo<ReadonlyArray<Column<Transaction>>>(
    () => [
      // {
      //   Header: (props) => <SelectionHeader tableProps={props}/>,
      //   id: 'selection',
      //   Cell: ({...props}) => <SelectionCell id={props.data[props.row.index].id}/>,
      // },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            title={I18n.t('Receiver')}
            className='min-w-250px'
          />
        ),
        id: 'b_party',
        Cell: ({ ...props }) => (
          <MediaInfoCell
            media={{
              url: `/transactions/${props.data[props.row.index].id}/`,
              title: props.data[props.row.index].b_party,
              subtitle: props.data[props.row.index].anonymous
                ? t('Anonymous')
                : props.data[props.row.index].contributor?.full_name,
              avatar: providerLogos[props.data[props.row.index].provider]
                ? toAbsoluteStatic(providerLogos[props.data[props.row.index].provider])
                : undefined,
            }}
          />
        ),
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            title={I18n.t('Amount')}
            className='w-110px'
          />
        ),
        accessor: 'amount',
        Cell: ({ ...props }) =>
          props.data[props.row.index].hide_amount ? (
            <>{t('Hidden')}</>
          ) : (
            <NumberCell
              value={props.data[props.row.index].amount}
              currency={props.data[props.row.index].currency}
              direction={1}
            />
          ),
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            title={I18n.t('Date')}
            className='w-110px'
          />
        ),
        accessor: 'ts',
        Cell: ({ ...props }) => (
          <DateCell value={props.data[props.row.index].ts} />
        ),
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            title={I18n.t('Location')}
            className='w-100px'
          />
        ),
        id: 'location',
        Cell: ({ ...props }) => (
          <MediaInfoCell
            media={{
              title: props.data[props.row.index].town,
              subtitle: props.data[props.row.index].region,
            }}
          />
        ),
      },
      // {
      //   Header: (props) => <CustomHeader tableProps={props} title={I18n.t('Reference')} className='w-120px'/>,
      //   accessor: 'name',
      //   // Cell: ({...props}) => <HeaderCell title={I18n.t(camelize(props.data[props.row.index].recurrence.toLowerCase()))} subtitle={props.data[props.row.index].next_run ? formatDate(props.data[props.row.index].next_run) : undefined} />,
      // },
      // ...(application ? [] : [{
      //   Header: (props) => <CustomHeader tableProps={props} title={I18n.t('Application')} className='w-100px'/>,
      //   accessor: 'application',
      //   Cell: ({...props}) => <span>{props.data[props.row.index].application?.name}</span>
      // }])
      // {
      //   Header: (props) => <CustomHeader tableProps={props} title={I18n.t('Actions')} className='text-end min-w-100px' />,
      //   id: 'actions',
      //   Cell: ({...props}) => (
      //     <div>
      //       <button className={'btn btn-icon btn-primary me-2'} onClick={() => {
      //         setSelected(props.data[props.row.index])
      //         setShowModal(true)
      //       }}><i className="fa-solid fa-pencil"></i></button>
      //       <ActionButton title={(<i className="fa-solid fa-trash"></i>)}
      //                     action={{path: `/payment/automations/${application.key}/`, method: 'delete'}}
      //                     className={'btn-icon btn-danger'}/>
      //     </div>
      //   ),
      // },
    ],
    []
  );
  return (
    <>
      <PaginatedList
        url={`/fund/contribute/${fund.slug}/contributions/`}
        columns={columns}
        showSearch={false}
        queryList={QUERIES.CONTRIBUTION_LIST}
      />
    </>
  );
}

export default FundContributions;
